import * as React from "react";
import styled, { css } from "styled-components";
import MenuItem from "./MenuItem";
const StyledMenuItem = styled(MenuItem)(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
  `
);
const DeleteMenuItem = ({ children = "Delete", ...props }) => /* @__PURE__ */ React.createElement(StyledMenuItem, { ...props }, children);
export default DeleteMenuItem;
